import { Component, OnInit } from '@angular/core';
import { E5coreUiWorkFieldTypeDateBaseComponent } from './e5core-ui-work-field-type-date-base';

@Component({
  selector: 'e5core-ui-work-field-type-date-box',
  templateUrl: './e5core-ui-work-field-type-date-box.component.html',
  styleUrls: ['./e5core-ui-work-field-type-date-box.component.css']
})
export class E5coreUiWorkFieldTypeDateBoxComponent extends E5coreUiWorkFieldTypeDateBaseComponent implements OnInit {
  ngOnInit(): void {
  }
}
